import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import AuthGuard from "@/features/auth/components/AuthGuard";

const Home = lazy(() => import("@/pages/home/page"));
const Dashboard = lazy(() => import("@/features/dashboard/pages/DashboardPage"));
const Login = lazy(() => import("@/pages/login/page"));
const Verify = lazy(() => import("@/pages/verify/page"));
const Plans = lazy(() => import("@/pages/plans/page"));
const Privacy = lazy(() => import("@/pages/privacy/page"));
const Terms = lazy(() => import("@/pages/terms/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

// eslint-disable-next-line react-refresh/only-export-components -- Route configuration and its fallback intentionally share this module.
function PageLoader() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="w-8 h-8 rounded-full border-2 border-primary-500 border-t-transparent animate-spin"></div>
    </div>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/login",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "/verify",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Verify />
      </Suspense>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <Suspense fallback={<PageLoader />}>
          <Dashboard />
        </Suspense>
      </AuthGuard>
    ),
  },
  {
    path: "/plans",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Plans />
      </Suspense>
    ),
  },
  {
    path: "/privacy",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Privacy />
      </Suspense>
    ),
  },
  {
    path: "/terms",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Terms />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<PageLoader />}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;
